<template>
  <section class="section" :style="renderBackground()">
    <div class="contact-form container">
      <ContactForm />
    </div>
  </section>
</template>

<script>
import ContactForm from "@/components/ContactForm.vue";
export default {
  name: "Contact",
  components: {
    ContactForm,
  },
  data() {
    return {
      backgroundImage:
        "https://images.unsplash.com/photo-1520372561567-bac27b0e5fa1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2048&q=80"
    };
  },
  methods: {
    renderBackground() {
      return {
        "background-image": `url('${this.backgroundImage}')`
      };
    }
  }
};
</script>

<style scoped>
.contact-form {
  padding-top: 3rem;
}
</style>